import { render, staticRenderFns } from "./ImportPage.vue?vue&type=template&id=2001c76e&scoped=true&"
import script from "./ImportPage.vue?vue&type=script&lang=js&"
export * from "./ImportPage.vue?vue&type=script&lang=js&"
import style0 from "./ImportPage.vue?vue&type=style&index=0&id=2001c76e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2001c76e",
  null
  
)

export default component.exports